/** ステータス */
export const IntervalMailSendingStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

/** レポート種別 */
export const TargetIOType = {
  ALL: 'all',
  SELECT: 'select',
}

/** レポート種別 */
export const Dimension = {
  INSERTION_ORDER: 'insertion_order',
  CAMPAIGN: 'campaign',
  DELIVERY_GROUP: 'delivery_group',
}

/** 集計間隔 */
export const Interval = {
  TOTAL: 'total',
  DAILY: 'daily',
  MONTHLY: 'monthly',
  INSERTION_ORDER_BUDGET: 'insertion_order_budget',
}

/** 集計期間 */
export const Period = {
  TOTAL: 'total',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  CURRENT_MONTH: 'current_month',
  LAST_MONTH: 'last_month',
  SELECT: 'select',
}

/** 送信間隔 */
export const SendInterval = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
}
